import { useEffect, useState } from 'react';

export const useFacebookSdk = () => {
  const [isFacebookSdkLoaded, setIsFacebookSdkLoaded] = useState(false);

  useEffect(() => {
    const facebooksdk = document.createElement('script');
    facebooksdk.src = 'https://connect.facebook.net/en_US/sdk.js';
    facebooksdk.async = true;
    facebooksdk.defer = true;
    document.body.appendChild(facebooksdk);
    facebooksdk.onload = () => {
      (window as any).fbAsyncInit = function () {
        (window as any).FB.init({
          appId: process.env.REACT_APP_FACEBOOK_APP_ID,
          autoLogAppEvents: true,
          xfbml: true,
          version: process.env.REACT_APP_FACEBOOK_API_VERSION,
        });
        setIsFacebookSdkLoaded(true);
      };
    };

    return () => {
      document.body.removeChild(facebooksdk);
    };
  }, []);

  useEffect(() => {
    if ((window as any).FB) {
      setIsFacebookSdkLoaded(true);
    }
  }, []);

  return { isFacebookSdkLoaded };
};
